import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleMissionAction = createAsyncThunk(
    'get-single-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-single-mission/${data}`,)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleMissionSlice = createSlice({
    name: 'get-single-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleMissionReducer = getSingleMissionSlice.reducer    